import React, { FC, memo, useCallback, useEffect, useMemo } from 'react'
import { useSetState } from 'ahooks'
// import { Popup, CalendarPickerView } from 'antd-mobile'
import CalendarPickerView from 'antd-mobile/es/components/calendar-picker-view/index'
import Popup from '@df-mobile/popup'
// import Popup from 'antd-mobile/es/components/popup/index'
// import ScalePrice from '../price'
import DfSinglePrice from '@df-mobile/df-single-price'
import style from './index.module.less'
import dayjs from 'dayjs'

interface IProps {
  visible: boolean
  value: Date | string
  onClose: () => void
  onChange: (date: Date | string) => void
  calendarDetailList: any[]
  icon?: string
}

interface IState {
  value: Date | string
}
const now = new Date()
const minDate = now
const maxDate = new Date(dayjs(now).add(2, 'month').format('YYYY-MM-DD'))

const CalendarComp: FC<IProps> = (props) => {
  const { value, visible, onClose, onChange, calendarDetailList, icon } = props
  const [state, setState] = useSetState<IState>({
    value: '',
  })

  const handleOK = () => {
    onChange(state.value ? new Date(state.value) : '')
    onClose()
  }

  useEffect(() => {
    setState({
      value: value,
    })
  }, [props, value])

  const filterList = useCallback((date: any) => {
    return calendarDetailList.filter((item) => {
      return item.date == dayjs(date).format('YYYY-MM-DD')
    })
  }, [calendarDetailList])

  return useMemo(() => {
    if (!visible) return null
    return (
      <Popup
        position="bottom"
        visible={visible}
        wrapClassName={style.CalendarPopup}
        onClose={onClose}
        destroyOnClose
        maskClosable
      >
        <div className={style.close} onClick={onClose}></div>
        <CalendarPickerView
          selectionMode='single'
          // multiple={false}
          value={new Date(state.value)}
          min={minDate}
          max={maxDate}
          onChange={(val: any) => setState({ value: val ? val : '' })}
          renderBottom={
            (date: Date) => filterList(date)[0]?.salePrice ? <div className={style.renderBottom}>
              <DfSinglePrice
                price={filterList(date)[0]?.salePrice}
                priceColor={dayjs(date).isSame(state.value, 'day') ? "#fff" : "#333"}
                iconSize={'XL10'}
                priceSize={'XL12'}
                icon={icon}
                // style={{color: dayjs(date).isSame(state.value, 'day') ? "#fff" : "#333", "font-size": "12px"}}
                // iconStyle={{'--width': '9px'}}
                
              />
              <span className={style.txt}>起</span>
              </div> : null
          }
          shouldDisableDate={(date: Date) => filterList(date).length == 0}
        />
        <div className={style.button} onClick={handleOK}>
          确定
        </div>
      </Popup>
    )
  }, [props, state])
}

export default memo(CalendarComp)
